<template>
    <div>
        <div class="page-wrapper">
            <div class="page-content-wrapper">
                <div class="col-12 shadow-btm row">
                    <div class="col-lg-6 col-sm-6 my-auto">
                        <h4 class="mb-0 lg-bld">Email Manager</h4>
                    </div>
                </div>

                <div class="page-content">
                    <div class="card-body py-0 px-0">
                        <!-- Search -->
                        <div class="row">
                            <div class="col-lg-6 col-sm-6 form-group row">
                                <div class="has-search ml-3">
                                    <i class="fa fa-search" style="position: absolute; margin: 10px"
                                        aria-hidden="true"></i>
                                    <input type="text" class="form-control" v-on:keyup.enter="getList(0)"
                                        placeholder="Search" v-model="searchObj.keyword" />
                                </div>
                                <a class="search-btn btn-style cursor-pointer ml-3" v-on:click="getList(0)">Search</a>
                                <a class="search-btn btn-style cursor-pointer" v-on:click="resetFilter">Reset</a>
                            </div>
                        </div>

                        <!-- Table -->
                        <div class="card border mb-0 radius-15">
                            <div class="card-body p-0 pb-4">
                                <div class="table-responsive">
                                    <div class="dataTables_wrapper dt-bootstrap4">
                                        <table class="table table-striped table-bordered dataTable" style="width: 100%"
                                            role="grid">
                                            <thead>
                                                <tr role="row">
                                                    <th>Sr No</th>
                                                    <th class="sorting" id="group-col"
                                                        v-on:click="sorting('group_name', 'group-col')">
                                                        Group Name
                                                    </th>
                                                    <th class="sorting" id="subject-col"
                                                        v-on:click="sorting('subject', 'subject-col')">
                                                        Subject
                                                    </th>
                                                    <th class="sorting" id="type-col"
                                                        v-on:click="sorting('type', 'type-col')">
                                                        Type
                                                    </th>
                                                    <!-- <th class="sorting" id="status-col"
                                                        v-on:click="sorting('status', 'status-col')">
                                                        Status
                                                    </th> -->
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody v-show="!loader">
                                                <tr v-for="(data, index) in list" :key="index">
                                                    <td>
                                                        {{
                                                            ($refs.listPagination.currentPage - 1) * $refs.listPagination.itemsPerPage +
                                                            index + 1
                                                        }}
                                                    </td>
                                                    <td>{{ data.group_name }}</td>
                                                    <td>{{ data.subject }}</td>
                                                    <td>
                                                        {{ data.type == "NEWS" ? "News" : "Deals & Transaction" }}
                                                    </td>
                                                    <!-- <td>
                                                        <a v-if="data.status === 'PENDING'"
                                                            class="reject-btn btn-style">PENDING</a>
                                                        <a v-else-if="data.status === 'IN_PROGRESS'"
                                                            class="fill-btn btn-style">IN PROGRESS</a>
                                                        <a v-else-if="data.status === 'COMPLETED'"
                                                            class="fill-btn btn-style">COMPLETED</a>
                                                        <a v-else-if="data.status === 'FAILED'"
                                                            class="reject-btn btn-style">FAILED</a>
                                                        <a v-else-if="data.status === 'DELETED'"
                                                            class="reject-btn btn-style">DELETED</a>
                                                        <a v-else class="btn-style">-</a>
                                                    </td> -->
                                                    <td>
                                                        <a class="fill-btn btn-style cursor-pointer"
                                                            v-on:click="$router.push('/view-email-logs/' + data.id)">View</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- Pagination -->
                                <div class="row mx-0 mb-4">
                                    <div class="col-lg-12 mt-5 text-center">
                                        <div class="page-bottom-pagination text-right">
                                            <Pagination @page-change="pageChange"
                                                @items-per-page-change="itemsPerPageChange" ref="listPagination" />
                                        </div>
                                    </div>
                                </div>

                                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DeleteModal @remove="deleteRecord($event)" @get-list="getList(0)" ref="deleteItem" />
    </div>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";

export default {
    name: "EmailLogs",
    components: {
        ErrorComponent,
        DeleteModal,
        Pagination,
    },
    data() {
        return {
            accessObject: this.$helperService.getAccessLevel("Manage Emails"),
            loader: true,
            searchObj: {},
            offset: -1,
            list: [],
            sortBy: "",     
            orderBy: "ASC",
        };
    },
    mounted() {
        this.getList(0);
    },
    methods: {
        pageChange(offset) {
            this.getList(offset - 1);
        },
        itemsPerPageChange() {
            this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
            this.getList(0);
        },
        getList(page, orderBy, sortBy) {
            this.$refs.errorComponent.updateListLoader(true);
            this.list = [];
            this.searchObj.offset = page;

            if (orderBy) this.searchObj.order_by = orderBy;
            if (sortBy) this.searchObj.sort_by = sortBy;

            this.$api
                .getAPI({
                    _action: "/email_logs/loglist",
                    _body: this.searchObj,
                })
                .then((res) => {
                    this.loader = false;
                    this.list = res.list;
                    this.offset = res.next_offset;
                    this.accessObject = this.$helperService.getAccessLevel("Manage Emails");

                    if (page == 0 && this.$refs.listPagination) {
                        this.$refs.listPagination.setTotalCount(res.count || 0);
                    }

                    if (this.$refs.errorComponent) {
                        this.$refs.errorComponent.setData(res, "No email logs available");
                        this.$refs.errorComponent.updateListLoader(false);
                    }
                })
                .catch(() => {
                    this.loader = false;
                    if (this.$refs.errorComponent) {
                        this.$refs.errorComponent.setData(0, undefined, "");
                        this.$refs.errorComponent.updateListLoader(false);
                    }
                });
        },
        sorting(sortBy, id) {
            var obj = this.$helperService.sorting(sortBy, id);
            this.getList(0, obj.order_by, obj.sort_by);
        },
        resetFilter() {
            this.searchObj.keyword = "";
            this.orderBy = "";
            this.sortBy = "";
            this.getList(0);
        },
        showDeletePopup(data) {
            this.$refs.deleteItem.showModal(
                "Delete Email Log",
                "Are you sure you want to delete " + data.subject,
                data
            );
        },
        deleteRecord(dataObj) {
            var detail = new Proxy(dataObj, {});
            this.$refs.deleteItem.deleteRecord("/email_logs/delete/" + detail.id);
        },
    },
};
</script>
